import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';

// Styles
import './styles/common.css';
import './styles/navbar.css';
import './styles/options.css';
import './styles/images.css';
import './styles/quicktrading.css';

// Providers
import { AppProvider } from './components/app/AppProvider';

// Pages
import { LoginPage } from './components/login/LoginPage';
import { TosPage } from './components/login/TosPage';
import { DashboardPage } from './components/dashboard/DashboardPage';
import { QuickTradingPage } from './components/quicktrading/QuickTradingPage';
import { ScannerPage } from './components/scanner/ScannerPage';
import { SnapTradeCallback } from './components/dashboard/SnapTradeCallback';

// Components
import { Navbar } from './components/app/Navbar';
import { Dimmer } from './components/app/Dimmer';
import { PWAInstallPrompt } from './components/app/PWAInstallPrompt';
import { ProtectedRoute } from './components/app/ProtectedRoute';

// Temporary components
import { TestButtons } from './components/app/_TestButtons';
import { BetaNotes } from './components/app/BetaNotes';

// Wrapper component that renders protected routes
const ProtectedRoutes = () => {
  return (
    <ProtectedRoute>
      <Outlet />
    </ProtectedRoute>
  );
};

const App = () => {
  return (
    <AppProvider>
        <Router>
          <div className="App">

            {process.env.NODE_ENV === 'production' ? <PWAInstallPrompt /> : null}
            <Dimmer />
            <Navbar />
            {/* <TestButtons /> */}

            {/* Define routes for different pages */}
            <main className="main-content">
              <BetaNotes />

              <Routes>

                {/* Public routes */}
                <Route path="/" element={<LoginPage />} />
                <Route path="/login/tos" element={<TosPage />} />
                <Route path="/connection-success" element={<SnapTradeCallback />} />

                {/* Protected routes - all wrapped together */}
                <Route element={<ProtectedRoutes />}>
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/quicktrading" element={<QuickTradingPage />} />
                  <Route path="/scanner" element={<ScannerPage />} />
                </Route>

              </Routes>

            </main>

            {/* Simply for debugging mobile width extents */}
            <div style={{
              position: 'fixed',
              border: '1px dotted gray',
              width: '400px',
              height: '100%',
              margin: 'auto',
              zIndex: 1000,
              pointerEvents: 'none',
            }} />

          </div>
        </Router>
    </AppProvider>
  );
}

export default App;
